import { defineMessages } from "react-intl";

export default defineMessages({
  bankTransfer: {
    id: "configureBankTransfer.bankTransfer",
    defaultMessage: "Bank transfer",
  },
  submit: {
    id: "configureBankTransfer.submit",
    defaultMessage: "Submit",
  },
});
